import React from "react";
import Stars from "../../../assets/images/star.svg"
const Star = ()=>{
    return(
        <>
        <img src={Stars} alt="star" loading="lazy"/>
        </>
    )
}
export default Star;